<template>
  <div class="calendar-field inline bottom center" :class="[$mq, {TA:isTestAchat}]">
    <date-picker
      :name="name"
      :key="open && $i18n.locale"
      :lang="lang"
      input-class="input input-calendar"
      :popup-class="`popup-calendar ${$mq} ${isTestAchat ? 'TA' : ''}`"
      :placeholder="$t('date')"
      :default-value="defaultDate"
      :disabled-date="rules"
      :value="value"
      value-type="format"
      v-on:input="update($event)"
      format="DD/MM/YYYY"
      :default-panel="defaultPanel"
      type="date"
      @change="handleChange"
      :clearable="false"
    >
    <template slot="icon-calendar">
      <SvgIcon icon="calendar"></SvgIcon>
    </template>
    </date-picker>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import fr from "vue2-datepicker/locale/fr";
import nl from "vue2-datepicker/locale/nl-be";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"]),
    lang() {
      let lang = fr;

      if (this.$i18n.locale === "fr") lang = fr;
      else lang = nl;

      return lang;
    },
  },
  props: {
    name: {
      type: String,
    },
    value: {
      type: null,
    },
    defaultPanel: {
      type: String,
      required: false,
      default: "year"
    },
    defaultDate: {
      type: Date,
      required: false,
      default: null,
    },
    rules: {
      type: Function,
      required: false,
      default: () => { return false }
    },
  },
  methods: {
    blur(value) {
      // this.open = false;
      // this.$emit("blur");
    },
    handleChange(value, type) {
      this.open = false;
      this.$emit("input", value);
    },
    update(value) {
      this.$emit("input", value);
    },
  },
  components: {
    DatePicker,
  },
};
</script>

<style lang="scss">
.calendar-field {
  position: relative;
}

.input.input-calendar {
  margin: 0 !important;
  border-radius: 4px !important;
}

.mx-datepicker-main {
  right: 40px;
}

.mx-datepicker {
  flex: 1 !important;
  width: 100%;
}

.today {
  background: $middleGrey;
  > div {
    color: $black;
  }
}

.mx-calendar {
  width: 100% !important;
}

.mx-icon-calendar {
  background: $clearYellow;
  padding: 7px;
  font-size: 1rem;
  border: 2px solid $yellow;
  border-left: 0px;
  border-radius: 0px 4px 4px 0px !important;
  right: 0!important;

  svg {
    fill: $black;
  }
}

.mx-calendar-content .cell.active {
  background: $yellow;
  color: $black;
}

.popup-calendar {
  border-radius: 15px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.3);

  &.desktop {
    width: 400px;

    .mx-datepicker-content {
      width: 400px;
    }

    .mx-datepicker {
      flex: 1 !important;
      width: 200px;
    }
  }

  &.TA {
    .mx-calendar-content .cell.active {
      background-color: $pink;
      color: $white;
    }
  }
}

.TA {
  .mx-icon-calendar {
    background: $pink;
    border: 2px solid $pink;
    
    svg {
      fill: $white;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Form/BecomeFields/CalendarField.vue